var _excluded = ["variant", "tooltip", "popover", "data-testid"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Popover } from '../../../containers/Popover';
import { StatusIconOutlined } from '../../../foundations/StatusIconOutlined';
import { StatusIconSolid } from '../../../foundations/StatusIconSolid';
import { forwardRef } from '../../../utils';
import { Tooltip } from '../../dataDisplay';
import { Box } from '../Box';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * @private For internal use only
 */
export var _IconIndicator = forwardRef((_ref, ref) => {
  var {
    variant = 'info',
    tooltip,
    popover,
    'data-testid': dataTestId = 'icon-indicator'
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  // Warning variant should be always solid due to accessibility
  var icon = variant === 'warning' ? /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
    as: StatusIconSolid,
    "data-component": "_IconIndicator",
    "data-testid": dataTestId
  }, props), {}, {
    ref: ref // ts-ignore is used due to `size` & `variant` issues with `<Box/>`.
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    ,
    size: "small",
    variant: "warning",
    tabIndex: tooltip ? 0 : -1
  })) : /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
    as: StatusIconOutlined,
    "data-component": "_IconIndicator",
    "data-testid": dataTestId
  }, props), {}, {
    ref: ref // ts-ignore is used due to `size` & `variant` issues with `<Box/>`.
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    ,
    size: "small",
    variant: variant === 'info' ? 'neutral' : variant,
    tabIndex: tooltip ? 0 : -1
  }));

  if (tooltip) {
    return /*#__PURE__*/_jsx(Tooltip, {
      label: tooltip.label,
      title: tooltip.title,
      children: icon
    });
  }

  if (popover) {
    return /*#__PURE__*/_jsx(Popover, _objectSpread(_objectSpread({}, popover), {}, {
      children: icon
    }));
  }

  return icon;
});
_IconIndicator.displayName = '_IconIndicator';
//# sourceMappingURL=_IconIndicator.js.map